import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

type JointPermissionType = 'read' | 'edit';

export type StandbyPalettePermissionJoinedDb = {
  jointPaletteId: string;
  paletteId: string;
  jointPermission: JointPermissionType;
}
const initial: StandbyPalettePermissionJoinedDb = {
  jointPaletteId: '',
  paletteId: '',
  jointPermission: 'read'
};

export type StandbyPalettePermissionJoinedDbHashType = {
  [key in string]: StandbyPalettePermissionJoinedDb;
}

export type StandbyPalettePermissionJoinedAddPayload = {
  id?: string;
} & StandbyPalettePermissionJoinedDb;
export type StandbyPalettePermissionJoinedUpdatePayload = {
  id: string;
} & { [P in keyof StandbyPalettePermissionJoinedDb]?: StandbyPalettePermissionJoinedDb[P] };

export type StandbyPalettePermissionJoinedDbState = {
  standbyPalettePermissionJoineds: StandbyPalettePermissionJoinedDbHashType;
}

export const generateStandbyPalettePermissionJoinedId = (): string => generateId('sppj');
let initialState: StandbyPalettePermissionJoinedDbState = { standbyPalettePermissionJoineds: {} };
const key = 'standbyPalettePermissionJoineds';

const standbyPalettePermissionJoinedDbSlice = createSlice({
  name: 'standbyPalettePermissionJoinedDb',
  initialState,
  reducers: {
    initializeStandbyPalettePermissionJoineds(state: StandbyPalettePermissionJoinedDbState) {
      state.standbyPalettePermissionJoineds = {};
    },
    addStandbyPalettePermissionJoined(state: StandbyPalettePermissionJoinedDbState, action: PayloadAction<StandbyPalettePermissionJoinedAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateStandbyPalettePermissionJoinedId();
      state.standbyPalettePermissionJoineds[id] = obj;
      saveData(key, id, obj);
    },
    updateStandbyPalettePermissionJoined(state: StandbyPalettePermissionJoinedDbState, action: PayloadAction<StandbyPalettePermissionJoinedUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.standbyPalettePermissionJoineds[id] === undefined) {
        console.log(`*** StandbyPalettePermissionJoined not found: ${id}`);
      } else {
        const newData = { ...state.standbyPalettePermissionJoineds[id], ...obj };
        state.standbyPalettePermissionJoineds[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteStandbyPalettePermissionJoined(state: StandbyPalettePermissionJoinedDbState, action: PayloadAction<StandbyPalettePermissionJoinedUpdatePayload>) {
      const id = action.payload.id;
      delete state.standbyPalettePermissionJoineds[id];
      deleteData(key, id);
    },
    saveStandbyPalettePermissionJoineds(state: StandbyPalettePermissionJoinedDbState) {
      saveAllData(key, state.standbyPalettePermissionJoineds);
    },
    signUpStandbyPalettePermissionJoineds(state: StandbyPalettePermissionJoinedDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.standbyPalettePermissionJoineds, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: StandbyPalettePermissionJoinedDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.standbyPalettePermissionJoineds = updatedValues;
      if (changed) saveAllData(key, state.standbyPalettePermissionJoineds);
    })
  }
})

export const { initializeStandbyPalettePermissionJoineds, addStandbyPalettePermissionJoined, updateStandbyPalettePermissionJoined, deleteStandbyPalettePermissionJoined, saveStandbyPalettePermissionJoineds, signUpStandbyPalettePermissionJoineds } = standbyPalettePermissionJoinedDbSlice.actions;
export default standbyPalettePermissionJoinedDbSlice.reducer;
